import React, { useEffect, useState } from 'react';

const logos = [
    { href: "https://www.zicta.zm", src: "/assets/resources/zicta-logo.png", alt: "zicta-logo" },
    { href: "https://web.facebook.com/AGSProgZambia", src: "/assets/resources/ags-logo.png", alt: "ags-logo" },
    { href: "https://www.undp.org/zambia", src: "/assets/resources/undp-logo.png", alt: "undp-logo" },
    { href: "https://ntbc.co.zm", src: "/assets/resources/ntbc-logo.jpg", alt: "ntbc-logo" },
    { href: "https://www.mtn.zm", src: "/assets/resources/mtn-logo.jpg", alt: "mtn-logo" },
    { href: "https://totalenergies.co.zm", src: "/assets/resources/total-energies-logo.png", alt: "total-energies-logo" },
    { href: "https://yunusenvironmenthub.com", src: "/assets/resources/yeh-logo.png", alt: "yeh-logo" },
    { href: "https://changemakerxchange.org", src: "/assets/resources/cx-logo.png", alt: "cx-logo" },
    { href: "https://www.undp.org/africa/projects/timbuktoo", src: "/assets/resources/timbuktoo-logo.png", alt: "timbuktoo-logo" }
];

const LogoCarousel = () => {
    const [visibleCount, setVisibleCount] = useState(6);

    useEffect(() => {
        // Determine how many logos to show based on screen width
        const updateVisibleCount = () => {
            const width = window.innerWidth;
            if (width < 576) setVisibleCount(1); // phones
            else if (width < 768) setVisibleCount(2); // small tablets
            else setVisibleCount(6); // default desktop
        };

        updateVisibleCount();
        window.addEventListener('resize', updateVisibleCount);

        const track = document.getElementById('logo-track');
        let currentIndex = 0;

        const interval = setInterval(() => {
            currentIndex++;

            if (currentIndex > logos.length - visibleCount) {
                currentIndex = 0;
            }

            const shiftPercent = -(100 / visibleCount) * currentIndex;
            if (track) {
                track.style.transform = `translateX(${shiftPercent}%)`;
            }
        }, 2000);

        return () => {
            clearInterval(interval);
            window.removeEventListener('resize', updateVisibleCount);
        };
    }, [visibleCount]);

    return (
        <div className="logo-carousel-wrapper overflow-hidden position-relative">
            <div className="logo-carousel d-flex transition" id="logo-track">
                {logos.map((logo, i) => (
                    <a
                        href={logo.href}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="d-flex align-items-center justify-content-center px-4"
                        style={{ flex: `0 0 ${100 / visibleCount}%` }}
                        key={i}
                    >
                        <img src={logo.src} className="img-fluid" alt={logo.alt}/>
                    </a>
                ))}
            </div>
        </div>
    );
};

export default LogoCarousel;
